import { render, staticRenderFns } from "./editReviewModal.vue?vue&type=template&id=e0ab529a&scoped=true&"
import script from "./editReviewModal.vue?vue&type=script&lang=js&"
export * from "./editReviewModal.vue?vue&type=script&lang=js&"
import style0 from "./editReviewModal.vue?vue&type=style&index=0&id=e0ab529a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ab529a",
  null
  
)

export default component.exports